import React, { useRef, useEffect } from 'react';

// Editor do texto do e-mail para o operador.
// Mostra o MIOLO da mensagem já formatado e deixa editar como num Word — sem
// HTML à vista. A moldura (logo, faixa navy, assinatura) fica no backend e é
// remontada no envio, então nem aparece aqui nem pode ser quebrada por engano.

const BOTOES = [
  { cmd: 'bold', icone: 'fa-bold', titulo: 'Negrito (Ctrl+B)' },
  { cmd: 'italic', icone: 'fa-italic', titulo: 'Itálico (Ctrl+I)' },
  { cmd: 'underline', icone: 'fa-underline', titulo: 'Sublinhado (Ctrl+U)' },
  { cmd: 'insertUnorderedList', icone: 'fa-list-ul', titulo: 'Lista' },
  { cmd: 'removeFormat', icone: 'fa-eraser', titulo: 'Limpar formatação' },
  { cmd: 'undo', icone: 'fa-rotate-left', titulo: 'Desfazer (Ctrl+Z)' },
];

const EditorEmail = ({ valor, onChange, altura = 320 }) => {
  const ref = useRef(null);

  // só escreve no DOM quando o conteúdo vem de fora (abrir/trocar de e-mail);
  // reescrever a cada tecla jogaria o cursor para o começo
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (valor || '')) {
      ref.current.innerHTML = valor || '';
    }
  }, [valor]);   // eslint-disable-line react-hooks/exhaustive-deps

  const comando = (cmd) => {
    ref.current?.focus();
    document.execCommand(cmd, false, null);
    onChange(ref.current?.innerHTML || '');
  };

  return (
    <div>
      <div className="d-flex gap-1 mb-1 flex-wrap">
        {BOTOES.map(b => (
          <button key={b.cmd} type="button" className="btn btn-sm btn-light border py-0 px-2"
            title={b.titulo}
            // onMouseDown evita perder a seleção do texto ao clicar no botão
            onMouseDown={(e) => { e.preventDefault(); comando(b.cmd); }}>
            <i className={`fas ${b.icone}`} style={{ fontSize: '.8rem' }}></i>
          </button>
        ))}
        <span className="small text-muted align-self-center ms-2">
          Edite o texto como quiser — o cabeçalho e a assinatura da Comece continuam iguais.
        </span>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        // cola sem trazer formatação da origem (Word, outro e-mail…)
        onPaste={(e) => {
          e.preventDefault();
          const texto = e.clipboardData.getData('text/plain');
          document.execCommand('insertText', false, texto);
        }}
        className="form-control"
        style={{
          height: `${altura}px`, overflowY: 'auto', background: '#fff',
          fontFamily: 'Segoe UI, Arial, sans-serif', fontSize: '14px', lineHeight: 1.6,
        }}
      />
    </div>
  );
};

export default EditorEmail;
